import * as cart from '@shopify/theme-cart';


export default () => {
  function init() {
    setEventBusListeners();
    checkForGift();
  }
  function setEventBusListeners() {
    Frame.EventBus.listen('AjaxCart:updated', async (response) => {
      console.log('AjaxCart:updated', response);
      const cartItems = await cart.getState();
      const total = await cartItems.total_price / 100;
      const gwp24 = theme && theme.gwp24;
      const threshold = gwp24.threshold;
      const gwpLineItems = document.querySelectorAll('.js-gwp-line-item');
      if (total >= threshold) {
        gwpLineItems.forEach((gwpLineItem) => {
          if (gwpLineItem.classList.contains('is-hidden')) {
            gwpLineItem.classList.remove('is-hidden');
          }
        });
      } else if (total < threshold) {
        gwpLineItems.forEach((gwpLineItem) => {
          if (!gwpLineItem.classList.contains('is-hidden')) {
            gwpLineItem.classList.add('is-hidden');
          }
        });
      }
    });
  }

  async function checkForGift() {
    const cartItems = await cart.getState();
    const gwp24 = theme && theme.gwp24;
    const variantId = parseInt(gwp24.variant.split('/').at(-1));
    const giftIsPresent = cartItems.items.some((el) => el.id === variantId);
    if (giftIsPresent) {
      cartItems.items.forEach((el) => {
        if (el.id === variantId) {
          const cartLineItemElement = document.querySelector(`.ajax-cart__line-item[data-key="${el.key}"]`);
          if (cartLineItemElement) {
            cart.removeItem(el.key).then((response) => {
              Frame.EventBus.emit('AjaxCart:itemRemoved', response);
            }).catch(() => {
              throw new Error('could not remove gift from cart');
            });
          }
        }
      });
    }
  }

  return {
    init,
  };
};
